import { CHART_AXIS_TICK_PROPS } from '../Chart.constants'

export const AREA_CHART_DEFAULT_PROPS = {
  margin: { bottom: 0, left: 0, right: 8, top: 8 },
}

export const AREA_CHART_GRID_DEFAULT_PROPS = {
  stroke: 'var(--color-border)',
  strokeDasharray: '3 3',
  vertical: false,
}

export const AREA_CHART_X_AXIS_DEFAULT_PROPS = {
  axisLine: false,
  interval: 'preserveStartEnd',
  minTickGap: 24,
  tick: CHART_AXIS_TICK_PROPS,
  tickLine: false,
}

export const AREA_CHART_Y_AXIS_DEFAULT_PROPS = {
  allowDecimals: false,
  axisLine: false,
  tick: CHART_AXIS_TICK_PROPS,
  tickLine: false,
  width: 36,
}

export const AREA_CHART_LEGEND_DEFAULT_PROPS = {
  align: 'center',
  iconSize: 10,
  iconType: 'circle',
  itemSorter: null,
  layout: 'horizontal',
  verticalAlign: 'bottom',
}

export const AREA_CHART_TOOLTIP_DEFAULT_PROPS = {
  cursor: { stroke: 'var(--secondary-text-color)', strokeDasharray: '3 3' },
}

// The dots would inherit the area's fill opacity otherwise.
export const AREA_DEFAULT_PROPS = {
  activeDot: { fillOpacity: 1, r: 5, strokeWidth: 0 },
  dot: { fillOpacity: 1, r: 3, strokeWidth: 0 },
  fillOpacity: 0.12,
  isAnimationActive: false,
  strokeWidth: 2,
  type: 'monotone',
}
